import styled from 'styled-components';
import customProfile from '../../../assets/image/profile/custom_profile.webp';
import customProfile2x from '../../../assets/image/profile/custom_profile@2x.webp';
import customProfile3x from '../../../assets/image/profile/custom_profile@3x.webp';

const profile_list = [customProfile3x, customProfile2x, customProfile3x];
export { profile_list };

export const Container = styled.table`
	border-collapse: separate;
	border-spacing: 0 1rem;
	gap: 0.5rem;
	margin-top: -2rem;
	${({ theme }) => theme.common.wh('100%', 'auto')};
	box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
	background-color: white;
	padding-bottom: 2rem;
	border-radius: 0 0 16px 16px;

	/* TimeSelectBox 드롭다운이 표시될 수 있도록 설정 */
	position: relative;

	thead {
		display: table;
		width: 100%;
		table-layout: fixed;
	}

	tbody {
		max-height: 1300px;
		overflow-y: auto;
		overflow-x: visible; /* x축은 visible로 설정 */
		position: relative; /* 추가 */

		width: 100%;

		/* 스크롤바 스타일 */
		&::-webkit-scrollbar {
			width: 6px;
		}

		&::-webkit-scrollbar-track {
			background: ${({ theme }) => theme.color.gray_f5};
			border-radius: 3px;
		}

		&::-webkit-scrollbar-thumb {
			background: ${({ theme }) => theme.color.gray_db};
			border-radius: 3px;
		}

		&::-webkit-scrollbar-thumb:hover {
			background: ${({ theme }) => theme.color.gray_c4};
		}

		tr {
			display: table;
			width: 100%;
			table-layout: fixed;
		}
	}

	th,
	td {
		padding: 0 1rem 0 0;
		white-space: nowrap;
		text-align: center;
	}
	tr {
		padding-right: 2rem;
	}
	thead {
		th {
			padding: 0 0.8rem 0 0;
			white-space: nowrap;

			text-align: center;
			vertical-align: middle;
			box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.02);
			//border: solid 1px #c9d6c8;
			//background-color: #f7f7f5;
			background-color: ${({ theme }) => theme.color.lightGreen};
			${({ theme }) => theme.common.wh('auto', '4.5rem')};
		}
		th:first-child {
			border-collapse: collapse;
			border-style: hidden;
		}
		th:last-child {
			width: 4rem;
			border-collapse: collapse;
			border-style: hidden;
		}
	}
	tbody {
		td {
			position: relative;
			text-align: center;
			vertical-align: middle;
			background-color: #fff;
			padding: 0 1rem 0 0;
			min-height: 4rem;
			min-width: 4rem;
			overflow: visible; /* 셀의 overflow를 visible로 설정 */

			${({ theme }) => theme.common.wh('auto', '4rem')};

			&.select {
				padding: 0.3rem 5px;
				overflow: visible; /* select 클래스도 visible로 */

				.box {
					& > div {
						border-radius: 8px;
					}
					position: relative;
					${({ theme }) => theme.common.wh('100%')}
					${({ theme }) => theme.common.flex()};
				}
				&.absence > div {
					pointer-events: none;
					cursor: default;
					filter: brightness(0.5);
					opacity: 0.5;
				}
			}
		}
		td:not(:first-child) {
			box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
		}
		td:first-child {
			background-color: transparent;
		}
		td:nth-child(2) {
			border-radius: 2rem 0 0 2rem;
			box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
		}
		td:last-child {
			border-collapse: collapse;
			border-style: hidden;
			box-shadow: none;
			background-color: transparent;
			/* border-radius: 0 1.6rem 1.6rem 0; */
		}
		td:nth-last-child(2) {
			border-collapse: collapse;
			border-style: hidden;
			/* border-radius: 0 1.6rem 1.6rem 0; */
		}
	}

	.deco {
		min-width: 4rem;
		width: 4rem;
		background-color: ${({ theme }) => theme.color.gray_db};

		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: white;
			border-radius: 0 2rem 2rem 0;
		}
	}

	.setButton {
		box-sizing: content-box;
		cursor: pointer;
		height: 100%;
		//padding-left: 5rem;
		border: none;
		border-radius: 0 2rem 2rem 0;
		background-color: ${({ theme }) => theme.color.gray_db};
		${({ theme }) => theme.common.wh('100%')}
		${({ theme }) => theme.common.flex()};
		display: flex;
		flex-direction: column !important;
		min-width: 5rem;
		img {
			height: 70%;
			aspect-ratio: 1;
			display: block;
		}
		p {
			font-size: 1.3rem;
			display: none;
		}
		&:hover img {
			display: none;
		}
		&:hover p {
			display: block;
		}
	}

	.select button {
		cursor: pointer;
		min-width: 10rem;
	}

	.index {
		color: gray;
	}
`;

export const SpinnerWrap = styled.div`
	display: flex;
	width: 100%;
	margin: 4rem 0;
	height: 100%;
	min-height: 12rem;
	justify-content: center;
	align-items: center;
	gap: 1rem;
	& > div {
		height: inherit;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	& > div > div {
		width: 30%;
	}
`;

export const TableWrap = styled.div`
	width: 100%;
	height: 200px;
	overflow-y: auto;
`;
